<template>
  <h4 class="font-weight-medium mb-2">
    {{ $t('L_contact_i_would_like_to') }}
  </h4>
  <v-select
    :id="idProp"
    v-model="formInput.$model"
    :disabled="disabled"
    :hint="selectHint"
    :items="items"
    :placeholder="$t('L_contact_placeholder')"
    :error-messages="errorMessages"
    @update:model-value="onInput"
    :aria-describedby="describers"
    :rules="[(v: unknown) => !!v || $t('L_reason_required')]"
    required
  />
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import BaseTextField from '../BaseTextField.vue';

const componentOptions: ComponentOptions = {
  name: 'ReasonInput',
  extends: BaseTextField,
  props: {
    idProp: {
      type: String,
      required: false,
      default: 'reason',
    },
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data: () => ({
    modelName: 'reason',
    reason: '',
  }),
  computed: {
    selectHint() {
      return this.formInput.$model === 'question'
        ? this.$t('L_contact_policy_question_hint')
        : undefined;
    },
  },
};

export default defineComponent(componentOptions);
</script>
